import * as Yup from 'yup';

export const PaystackAccountSchema = Yup.object().shape({
  bankCode: Yup.string().required('Required'),
  bankAccountNumber: Yup.string()
    .required('Required')
    .test('invalid', 'Please enter a valid account number', name =>
      /^\d{9,10}$/.test(name || ''),
    ),
  subaccountName: Yup.string()
    .required('Required')
    .test('invalid', 'Please enter a valid subaccount Name', name =>
      /^[a-zA-Z]+ [a-zA-Z]+/.test(name || ''),
    ),
});
